import { themeTypeToBool } from './../../../../utils/helpers';

export default theme => ({
    container: {
        margin: theme.spacing(1)
    },
    header: {
        display: "flex",
        alignItems: "center",
        marginBottom: theme.spacing(1)
    },
    content: {
        display: "flex",
        flexDirection: "column"
    },
    button: buttonStyle(theme)
});

export const buttonStyle = theme => ({
    margin: theme.spacing(0.5),
    borderColor: themeTypeToBool(theme.palette.type) ? "#43425D" : "inherit"
});